import CloseIcon from "assets/svgs/placement/Close"
import { useAuth } from "core/context/auth"
import React from "react"

interface MockFeedbackCardProps {
  studentDetails: any
  onCancel: () => void
  handleFeedbackChange: (email: string, feedback: string) => Promise<void>
  newFeedback: string
  setNewFeedback: (feedback: string) => void
}

const MockFeedbackCard: React.FC<MockFeedbackCardProps> = ({
  studentDetails,
  onCancel,
  handleFeedbackChange,
  newFeedback,
  setNewFeedback,
}) => {
  const { auth } = useAuth()

  const handleSave = async () => {
    if (!newFeedback.trim()) {
      alert("Feedback cannot be empty")
      return
    }

    try {
      await handleFeedbackChange(studentDetails.general_information.email, newFeedback)
    } catch (error) {
      console.error("Error saving feedback:", error)
    }
  }

  return (
    <div className="bg-white shadow-md rounded-lg p-[24px] h-auto w-[400px] relative">
      <button className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" onClick={onCancel}>
        <CloseIcon className="h-6 w-6" />
      </button>
      <p className="text-[16px] font-semibold text-[#333333]">Student's Mock Feedback</p>
      <p className="pt-1 text-[14px] text-[#646464]">
        {studentDetails?.general_information?.name || "N/A"} | {studentDetails?.general_information?.email || "N/A"}
      </p>
      <div className="py-6">
        <label className="block mt-4 text-[#333333] font-semibold">Feedback</label>
        <textarea
          value={newFeedback}
          onChange={(e) => setNewFeedback(e.target.value)}
          className="w-full h-32 border-[0.5px] border-[#D3D3D3] rounded-md p-2"
          placeholder="Enter mock feedback"
        />
      </div>
      <div className="flex justify-end gap-4 mt-4">
        <button className="border-[0.5px] border-[#D3D3D3] text-[#333333] rounded-md px-4 py-2" onClick={onCancel}>
          Cancel
        </button>
        <button className="bg-[#001665] text-white rounded-md px-4 py-2" onClick={handleSave}>
          Save
        </button>
      </div>
    </div>
  )
}

export default MockFeedbackCard
